/** @file channelsOfColorType: samples per pixel for a PNG colour type. */
import type { PngHeader } from './pngHeader';

const CHANNELS = { 0: 1, 2: 3, 3: 1, 4: 2, 6: 4 } as const;

/** 1 (grey, palette), 2 (grey + alpha), 3 (RGB) or 4 (RGBA). */
export function channelsOfColorType(colorType: PngHeader['colorType']): number {
  return CHANNELS[colorType];
}
